import { Button, Card, CardActions, CardContent, IconButton, Link, TextField, makeStyles } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { postLoginStepState, stepState, userState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { clientLogin } from 'services/authentication.service';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import ReactJson from 'react-json-view';
import { toast } from 'react-hot-toast';
import { STEP_CREATE_ACCOUNT, STEP_PERSONAL_DETAILS, STEP_SERVICE_BREAKDOWN, STEP_SIGN_IN } from 'pages/CustomerBookingCreate/constants';
import { PrivPolLink } from 'pages/CustomerBookingCreate/components/PrivPolLink';
import { useHistory } from 'react-router-dom';
import { useUrlState } from '@zennya/web-component-library/src';
import { useTrackEvent } from 'util/trackEvent';
import { activeUserState } from 'pages/CustomerBooking';
import { fingerprintState } from 'util/deviceUUID';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(5),
  },
  cardContent: {
    "&>*": {
      marginBottom: theme.spacing(5)
    }
  },
  cardAction: {
    justifyContent: 'flex-end'
  }
}));
const SignInScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const [postLoginStep, setPostLoginStep] = useRecoilState(postLoginStepState);
  const [user, setUser] = useRecoilState(userState);
  const fingerprint = useRecoilValue(fingerprintState)
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const history = useHistory()
  const trackEvent = useTrackEvent()
  const setActiveUser = useSetRecoilState(activeUserState);

  const [bookingId, setBookingId] = useUrlState({
    queryKey: 'bookingId',
    defaultValue: null
  });

  const doLogin = useCallback(
    async () => {
      try {
        const user = await clientLogin({ email, password, fingerprint: fingerprint })
        setUser(user)
        setActiveUser(user)
        if (bookingId) {
          history.replace(`/bookings/${bookingId}`)
          window?.location?.reload()
        } else {
          if (postLoginStep) {
            setStep(postLoginStep)
            history.replace(postLoginStep, { internal: true })
          } else {
            setStep(step)
            history.replace(step, { internal: true })
          }
        }
      } catch (error) {
        trackEvent('Create Booking Sign In - Error', { error: error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details })
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, { error })
        setError(error?.message?.en)
      }
    },
    [email, password, fingerprint, step, postLoginStep],
  );
  return (
    <>
      <PageHeader title="Sign into your account"
        isCartEnabled={false}
        currentStep={STEP_SIGN_IN}
        backStep={STEP_SERVICE_BREAKDOWN}
        showBreadcrumbs
        subheader={!bookingId &&
          (
            <>
              If you don’t have an account yet,
              <Link onClick={() => {
              trackEvent('Create Booking Sign In - Click sign up instead')
                setStep(STEP_CREATE_ACCOUNT)
                history.replace(STEP_CREATE_ACCOUNT, { defer: true })
              }}>
                Sign up instead
              </Link>
            </>
          )
        }
      >
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <TextField
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              fullWidth
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
              fullWidth
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
            />
            <Button
              disabled
              variant='text'
              color='primary'
            >
              Forgot password?
            </Button>
            <PrivPolLink />
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              disabled={!email || !password}
              variant="contained"
              color="primary"
              onClick={() => {
                trackEvent('Create Booking Sign In - Click sign in button')
                doLogin()
              }}
            >
              Sign in
            </Button>
          </CardActions>

        </Card>
      </PageHeader >
    </>
  )
}

export { SignInScreen }